import type { TenantConfig } from './types';

export const crmTenant: TenantConfig = {
  variant: 'crm',
  logoUrl: '',
};
